import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=8ee07714&scoped=true"
import script from "./MemberProfile.vue?vue&type=script&lang=js"
export * from "./MemberProfile.vue?vue&type=script&lang=js"
import style0 from "./MemberProfile.vue?vue&type=style&index=0&id=8ee07714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee07714",
  null
  
)

export default component.exports